/**
 * Indicador de conexión + banner Offline / Online / cola pendiente.
 */

const BANNER_CSS = `
#poskn-sync-banner{
	display:none;position:sticky;top:0;z-index:4000;width:100%;box-sizing:border-box;
	padding:9px 12px;font-size:13px;font-weight:700;text-align:center;
	font-family:inherit;letter-spacing:.01em;cursor:default;
	align-items:center;justify-content:center;flex-wrap:wrap;gap:8px 12px;
	pointer-events:auto;
}
#poskn-sync-banner.is-visible{display:flex !important;}
#poskn-sync-banner.is-pending{animation:poskn-sync-pulse 1.5s ease-in-out infinite;}
#poskn-sync-banner .poskn-sync-msg{flex:1 1 auto;min-width:180px;}
#poskn-sync-banner .poskn-sync-actions{display:inline-flex;gap:8px;flex-shrink:0;}
#poskn-sync-banner .poskn-sync-actions button{
	border:none;border-radius:4px;padding:5px 12px;font-weight:700;font-size:12px;cursor:pointer;
	background:#fff;color:#b71c1c;
}
#poskn-sync-banner.is-syncing .poskn-sync-actions button{color:#1565c0;}
#poskn-sync-banner.is-offline .poskn-sync-actions button{color:#b71c1c;}
#poskn-sync-banner.is-business .poskn-sync-actions button{color:#e65100;}
@keyframes poskn-sync-pulse{0%,100%{filter:brightness(1)}50%{filter:brightness(1.12)}}
#barra-pendientes-subir{display:none !important;}
`;

function ensureBanner(win, $) {
	if (!$('#poskn-sync-banner-css').length) {
		$('head').append(`<style id="poskn-sync-banner-css">${BANNER_CSS}</style>`);
	}
	if ($('#poskn-sync-banner').length) return;
	const html = `<div id="poskn-sync-banner" role="status" aria-live="polite"></div>`;
	const $body = $('body');
	if ($body.length) $body.prepend(html);
}

function bindBannerOnce(win, $) {
	if (win._posknSyncBannerBound) return;
	win._posknSyncBannerBound = true;
	$(document).on('click', '#poskn-sync-ver', (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (typeof win.verListaPendientesSubir === 'function') win.verListaPendientesSubir();
	});
	$(document).on('click', '#poskn-sync-retry', (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (typeof win.procesarColaSubida === 'function') win.procesarColaSubida();
	});
	$(document).on('click', '#poskn-sync-probe', (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (typeof win.posknProbeServer === 'function') {
			win.posknProbeServer(true);
		}
	});
}

function firstQueueError(win) {
	try {
		const cola = typeof win.getColaPendientesSubir === 'function' ? win.getColaPendientesSubir() : [];
		for (let i = 0; i < cola.length; i++) {
			if (cola[i] && cola[i]._error_servidor) return String(cola[i]._error_servidor);
		}
	} catch (e) {
		/* ignore */
	}
	return '';
}

export function initConnectionStatus(win, $) {
	if (win._posknConnectionBound) return;
	win._posknConnectionBound = true;

	win.posknUpdateConnectionStatus = function posknUpdateConnectionStatus() {
		ensureBanner(win, $);
		bindBannerOnce(win, $);
		const navOnline = win.navigator.onLine;
		const serverOk = win.posknServerReachable;
		// Un health OK manda sobre navigator.onLine (Chrome a veces lo deja en false tras un corte).
		const online = serverOk === true || (navOnline && serverOk !== false);
		const $el = $('#poskn-connection-status');
		const $banner = $('#poskn-sync-banner');

		const cola =
			typeof win.getColaPendientesSubir === 'function' ? win.getColaPendientesSubir() : [];
		const pending = cola.length;
		let failedBiz = 0;
		cola.forEach((item) => {
			if (item && item.outbox_status === 'failed_business') failedBiz += 1;
		});
		const pendingNet = Math.max(0, pending - failedBiz);
		const syncing = !!win.posknQueueSyncing;
		const terminal =
			typeof win.posknGetRegisterLabel === 'function' ? win.posknGetRegisterLabel() : '';
		const termSuffix = terminal ? ` · ${terminal}` : '';
		const errHint = firstQueueError(win);
		const errShort = errHint ? ` · ${errHint.slice(0, 80)}` : '';

		let bannerText = '';
		let bannerBg = '';
		let bannerColor = '#fff';
		let cls = '';

		if (syncing && pendingNet > 0) {
			if ($el.length) {
				$el.css({ color: '#1565c0' }).text(`↻ Subiendo ${pendingNet}${termSuffix}`);
				$el.attr('title', 'Subiendo pedidos en cola al servidor');
			}
			bannerText = `Subiendo ${pendingNet} pedido(s) al servidor… El POS sigue activo.`;
			bannerBg = '#1565c0';
			cls = 'is-syncing is-pending';
		} else if (!online) {
			const suffix = pending > 0 ? ` · ${pending} cola` : '';
			const sinNet = navOnline === false;
			const label = sinNet ? 'Sin internet' : 'Servidor no responde';
			if ($el.length) {
				$el.css({ color: '#c62828' }).text(`○ ${label}${suffix}${termSuffix}`);
				$el.attr(
					'title',
					sinNet
						? 'No hay red. Sigue vendiendo: los cobros van a cola local.'
						: 'El servidor no responde. Sigue vendiendo: los cobros van a cola local.',
				);
			}
			bannerText =
				pending > 0
					? `${label}. Sigue vendiendo — ${pending} en cola. No bloquea el POS.`
					: `${label}. Sigue vendiendo; los cobros nuevos van a cola. No bloquea el POS.`;
			bannerBg = '#b71c1c';
			cls = pending > 0 ? 'is-offline is-pending' : 'is-offline';
		} else if (pendingNet > 0) {
			if ($el.length) {
				$el.css({ color: '#c62828' }).text(`● ${pendingNet} pendiente(s)${termSuffix}`);
				$el.attr('title', 'Hay pedidos en cola local. Usa Ver o Subir ahora.');
			}
			bannerText = `${pendingNet} pedido(s) pendientes de subir.${errShort} El POS sigue activo.`;
			bannerBg = '#c62828';
			cls = 'is-pending';
		} else if (failedBiz > 0) {
			if ($el.length) {
				$el.css({ color: '#e65100' }).text(`● ${failedBiz} con error${termSuffix}`);
				$el.attr('title', 'Cobros que el servidor rechazó (stock u otro). El POS no está bloqueado.');
			}
			bannerText = `${failedBiz} cobro(s) con error de negocio${errShort}. El POS sigue funcionando. Ver o Anular.`;
			bannerBg = '#e65100';
			cls = 'is-business';
		} else if ($el.length) {
			$el.css({ color: '#2e7d32' }).text(`● En línea${termSuffix}`);
			$el.attr('title', 'Conexión activa');
		}

		if ($banner.length) {
			if (bannerText) {
				const actions =
					pending > 0
						? `<span class="poskn-sync-actions"><button type="button" id="poskn-sync-ver">Ver</button>${pendingNet > 0 ? `<button type="button" id="poskn-sync-retry">${syncing ? 'Subiendo…' : 'Subir ahora'}</button>` : ''}${!online ? '<button type="button" id="poskn-sync-probe">Reintentar red</button>' : ''}</span>`
						: `<span class="poskn-sync-actions"><button type="button" id="poskn-sync-probe">Reintentar red</button></span>`;
				$banner
					.attr('class', `is-visible ${cls}`.trim())
					.css({ background: bannerBg, color: bannerColor })
					.html(`<span class="poskn-sync-msg">${bannerText.replace(/</g, '&lt;')}</span>${actions}`);
				if (syncing) $('#poskn-sync-retry').prop('disabled', true);
			} else {
				$banner.removeClass('is-visible is-pending is-syncing is-offline is-business').empty();
			}
		}
	};

	$(() => {
		ensureBanner(win, $);
		bindBannerOnce(win, $);
		win.posknUpdateConnectionStatus();
	});
	win.addEventListener('online', win.posknUpdateConnectionStatus);
	win.addEventListener('offline', win.posknUpdateConnectionStatus);
	win.setInterval(() => {
		if (typeof win.posknUpdateConnectionStatus === 'function') {
			win.posknUpdateConnectionStatus();
		}
	}, 4000);
}
